import { configureStore } from "@reduxjs/toolkit";
import getStartedReducer from "../components/content/GetStarted/GetStartedSlice";

export const store = configureStore({
  reducer: {
    getStarted: getStartedReducer
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch